import { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import AssessmentComposer from "@/components/site/AssessmentComposer";
import Trust from "@/components/site/Trust";
import HowItWorks from "@/components/site/HowItWorks";
import Solutions from "@/components/site/Solutions";
import Organizations from "@/components/site/Organizations";
import Philosophy from "@/components/site/Philosophy";
import ForWho from "@/components/site/ForWho";
import WhyFreelancAI from "@/components/site/WhyFreelancAI";
import AIOpportunity from "@/components/site/AIOpportunity";
import { useDiagnostic } from "@/features/diagnostic/DiagnosticContext";

export default function Home() {
  const { state } = useDiagnostic();

  useEffect(() => {
    if (state.submitted) document.getElementById("assessment")?.scrollIntoView({ block: "start" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="theme-light min-h-screen overflow-x-clip bg-canvas text-fg">
      <Nav />
      <main>
        <Hero />
        <AssessmentComposer />
        <Trust />
        <HowItWorks />
        <Solutions />
        <Organizations />
        <ForWho />
        <WhyFreelancAI />
        <AIOpportunity />
        <Philosophy />
      </main>
    </div>
  );
}
